var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.854 18.1465C18.9478 18.2403 19.0006 18.3676 19.0006 18.5003C19.0006 18.633 18.9478 18.7602 18.854 18.854C18.7602 18.9478 18.633 19.0006 18.5003 19.0006C18.3676 19.0006 18.2403 18.9478 18.1465 18.854L9.50028 10.2078L0.854028 18.854C0.760208 18.9478 0.63296 19.0006 0.500278 19.0006C0.367596 19.0006 0.240349 18.9478 0.146528 18.854C0.0527079 18.7602 2.61548e-09 18.633 0 18.5003C-2.61548e-09 18.3676 0.0527074 18.2403 0.146528 18.1465L8.79278 9.50028L0.146528 0.854028C0.0527074 0.760208 0 0.63296 0 0.500278C0 0.367596 0.0527074 0.240348 0.146528 0.146528C0.240348 0.0527074 0.367596 0 0.500278 0C0.63296 0 0.760208 0.0527074 0.854028 0.146528L9.50028 8.79278L18.1465 0.146528C18.193 0.100073 18.2481 0.0632225 18.3088 0.0380812C18.3695 0.0129398 18.4346 1.29505e-09 18.5003 0C18.566 -1.29505e-09 18.631 0.0129398 18.6917 0.0380812C18.7524 0.0632225 18.8076 0.100073 18.854 0.146528C18.9005 0.192983 18.9373 0.248133 18.9625 0.30883C18.9876 0.369526 19.0006 0.434581 19.0006 0.500278C19.0006 0.565975 18.9876 0.63103 18.9625 0.691726C18.9373 0.752423 18.9005 0.807573 18.854 0.854028L10.2078 9.50028L18.854 18.1465Z",
    fill: "#4D5F6E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-icon.51556571d308a0296cbe6f356a7976fd.svg";